import type { FunctionComponent } from "react";
import type { PreloadedQuery } from "react-relay";
import { graphql, useFragment, usePreloadedQuery } from "react-relay";

import { query } from "~/components/header/header-oneline-menu-container";
import { useOnelineMenuTracking } from "~/components/header/header-oneline-menu-container/hooks";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";
import { useEditionValue } from "~/lib/edition";
import { useCurrentPageType } from "~/lib/router/hooks";
import type { headerOnelineMenuContainerQuery } from "~/queries/__generated__/headerOnelineMenuContainerQuery.graphql";
import type { headerOnelineMenuStyleQuery$key } from "~/queries/__generated__/headerOnelineMenuStyleQuery.graphql";

import { Container, StyledEntityLink, StyledSectionStyleHeaderMenuItem } from "./styles";

export type Props = {
  queryReference: PreloadedQuery<headerOnelineMenuContainerQuery>;
};

export const HeaderOnelineMenuStyle: FunctionComponent<Props> = ({ queryReference }) => {
  const data_ = usePreloadedQuery(query, queryReference);

  const data = useFragment<headerOnelineMenuStyleQuery$key>(
    graphql`
      fragment headerOnelineMenuStyleQuery on Query {
        styleOnelineMenu: queue(filter: { name: "scmp_pwa_oneline_menu_style" }) {
          items(first: 6) {
            edges {
              node {
                ... on Section {
                  ...entityLink
                  ...sectionStyleHeaderMenuItem
                  name
                }
              }
            }
          }
        }
      }
    `,
    data_,
  );

  const edition = useEditionValue({ initializeWithValue: true });

  const { edition: trackingEdition } = useOnelineMenuTracking();
  const currentPageType = useCurrentPageType();
  return (
    <Container>
      {data.styleOnelineMenu?.items?.edges.map((edge, index) => (
        <StyledEntityLink
          key={index}
          query={{
            module: `oneline_menu_section_${edition}`,
            pgtype: currentPageType,
          }}
          reference={edge.node}
          onClick={() => {
            sendGATracking({
              action: "Linemenu/Click",
              category: "Menu",
              label: `${trackingEdition}/Linemenu/Click/${edge.node.name ?? ""}`,
            });
          }}
        >
          <StyledSectionStyleHeaderMenuItem reference={edge.node} />
        </StyledEntityLink>
      ))}
    </Container>
  );
};

HeaderOnelineMenuStyle.displayName = "HeaderOnelineMenuStyle";
